import { render, staticRenderFns } from "./CardPlusOutline.vue?vue&type=template&id=489e8532"
import script from "./CardPlusOutline.vue?vue&type=script&lang=js"
export * from "./CardPlusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports